// Parse the time to string
export const parseTime = (
  time?: object | string | number | null,
  cFormat?: string
 ): string | null => {
  if (time === undefined || !time) {
    return null
  }
  const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}'
  let date: Date
  if (typeof time === 'object') {
    date = time as Date
  } else {
    if (typeof time === 'string') {
      if (/^[0-9]+$/.test(time)) {
        time = parseInt(time)
      } else {
        time = time.replace(new RegExp(/-/gm), '/')
      }
    }
    if (typeof time === 'number' && time.toString().length === 10) {
      time = time * 1000
    }
    date = new Date(time)
  }
  const formatObj: { [key: string]: number } = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay()
  }
  const timeStr = format.replace(/{([ymdhisa])+}/g, (result, key) => {
    const value = formatObj[key]
    // Note: getDay() returns 0 on Sunday
    if (key === 'a') {
      return ['日', '一', '二', '三', '四', '五', '六'][value]
    }
    return value.toString().padStart(2, '0')
  })
  return timeStr
}

export const getTimestamp = function(dt: string){
	var date = dt.split(' ');
	var year:any = dt[0].split('-')[0];
	var month:any = +dt[0].split('-')[1]-1;
	var day:any = dt[0].split('-')[2];
	var hour:any = dt[1].split(':')[0];
	var minute:any = dt[1].split(':')[1];
	var second:any = dt[1].split(':')[2];
	
	return new Date(year, month, day, hour, minute, second).getTime();
}

export const getToday = function(){
  var dt = timeObj(new Date());
  return [dt.year, dt.month, dt.day].join('-') + '/' + [dt.year, dt.month, dt.day].join('-')
}

export const getYestarDay = function(){
  var dt = timeObj(new Date());

  var dt1 = timeObj(new Date(dt.year,+dt.month-1, +dt.day-1));

  return [dt1.year, dt1.month, dt1.day].join('-') + '/' + [dt1.year, dt1.month, dt1.day].join('-')
}

export const getBeforeYestarDay = function(){
  var dt = timeObj(new Date());

  var dt1 = timeObj(new Date(dt.year,+dt.month-1, +dt.day-2));

  return [dt1.year, dt1.month, dt1.day].join('-') + '/' + [dt1.year, dt1.month, dt1.day].join('-')
}
export const getInSevenDay = function(){
  var dt = timeObj(new Date());
  var dt1 = timeObj(new Date(dt.year,+dt.month-1, +dt.day-6));

  return [dt1.year, dt1.month, dt1.day].join('-') + '/' + [dt.year, dt.month, dt.day].join('-')
}

function fillZero(number){
  if (number > 9){
    return number;
  }else{
    return '0'+number;
  }
}
function timeObj(date){
  var year = date.getFullYear();
  var month = fillZero(date.getMonth()+1);
  var day = fillZero(date.getDate());
  var hour = fillZero(date.getHours());
  var minute = fillZero(date.getMinutes());
  var second = fillZero(date.getSeconds());
  return {
    year, month, day, hour, minute, second
  }
}

// 格式化价格
export const toThousands = (s: string, type = "price") => {
  const n = 2;
  s = parseFloat((s + '').replace(/[^\d\.-]/g, '')).toFixed(n) + '';
  const l = s.split('.')[0].split('').reverse();
  const r = s.split('.')[1];
  let t = '';
  for (let i = 0; i < l.length; i++) {
    t += l[i] + ((i + 1) % 3 === 0 && (i + 1) !== l.length ? ',' : '');
  }
  if (type == 'price') {
    return t.split('').reverse().join('') + '.' + r;
  } else if (type === 'num') {
    return t.split('').reverse().join('');
  }
}

// http替换为https
export function replaceToHttps(url: string) {
  const reg = new RegExp('http://', 'g')
  return url.replace(reg, 'https://')
}

// download file
export function downloadFile(url: string) {
  const a = document.createElement('a')
  a.href = url // 这里的请求方式为get，如果需要认证，接口上需要带上token
  a.click()
}


/*
type  1当月1号  2当天 
detail 显示十分秒
number 相差几天 (订单管理/代理订单 默认查询前一天)
*/
export function getSearchDate(type:number,detail?:boolean,number?:number){
  let date = new Date()
  if(number){
    date = new Date(new Date().getTime()+1000*60*60*24*number)
  }
  const year = date.getFullYear()
  const month = date.getMonth()+1>9?date.getMonth()+1:'0'+(date.getMonth()+1)
  const day = date.getDate()>9?date.getDate():'0'+date.getDate()


  const start = type==1?([year,month,'01'].join('-')+(detail?' 00:00:00':'')):([year,month,day].join('-')+(detail?' 00:00:00':''))
  const end = [year,month,day].join('-')+(detail?' 23:59:59':'')
  return [start,end]
}

// days往后算的天数  seconds往后算的秒数
export function nextDay(time:string,days?:number,seconds?:number){
  if(!time) return ''
  let source:any = time
  if(days){
    source = new Date(new Date(time).getTime()+1000*60*60*24*days)
  }
  if(seconds){
    source = new Date(new Date(time).getTime()+seconds*1000)
  }
  let date = new Date(source)
  const year = date.getFullYear()
  const month = date.getMonth()+1>=10?date.getMonth()+1:'0'+(date.getMonth()+1)
  const day = date.getDate()>=10?date.getDate():'0'+date.getDate()
  const hour = date.getHours()>=10?date.getHours():'0'+date.getHours()
  const min = date.getMinutes()>=10?date.getMinutes():'0'+date.getMinutes()
  const sec = date.getSeconds()>=10?date.getSeconds():'0'+date.getSeconds()
  let newTime = [year,month,day].join('-') + (seconds!=undefined?(' '+[hour,min,sec].join(':')):'')
  return newTime
}

export function nowtime(){
  const date = new Date()
  const year = date.getFullYear()
  const month = date.getMonth()+1>9?(date.getMonth()+1):'0'+(date.getMonth()+1)
  const day = date.getDate()>9?date.getDate():'0'+date.getDate()
  const hour = date.getHours()>9?date.getHours():'0'+date.getHours()
  const min = date.getMinutes()>9?date.getMinutes():'0'+date.getMinutes()
  const sec = date.getSeconds()>9?date.getSeconds():'0'+date.getSeconds()
  return [year,month,day].join('-') + ' ' + [hour,min,sec].join(':')
}
/*
  type  1 1号  2 当天
*/
export function lastmonth(num:number,type){
  const date = new Date()
  let year = Number(date.getFullYear())
  let month:number = (date.getMonth()+1)
  const day = date.getDate()>=10?date.getDate():'0'+date.getDate()
  // console.log(month,num)
  if(month-num <= 0){
    month = month+(12-num)
    year-=1
  }else if(month-num > 12){
    month = month-12-num
    year+=1
  }else{
    month = month - num
  }
  // console.log(month)
  const newmonth:any = month>9?month:'0'+month
  if(type==1){
    return [year,newmonth,'01'].join('-')
  }else if(type==2){
    return [year,newmonth,day].join('-')
  }
}

//把base64转成file文件 再上传
export function dataURLtoFile(url,filename?:string){
  const arr = url.split(',')
  const mime = arr[0].match(/:(.*?);/)[1]
  const bstr = atob(arr[1])
  let n = bstr.length
  const suffixArr = mime.split( "/" )
  if (suffixArr.length && !filename) {
    const  suffix = suffixArr[suffixArr.length - 1]
    filename =  new  Date().getTime() +  "-"  + Math.floor((Math.random() * 10000)) +  "."  + suffix
   }
   const u8arr = new Uint8Array(n)
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }
  return  new  File([u8arr], filename, { type: mime })
}


//自定义链接弹窗type转换 把接口用的转成我这里用的
export function chooseLinkConvert(type:number){
  let msg = {
    pagetype:1,
    subdivideType:1,
    Id:0
  }
  if(type==6){
    msg.pagetype = 1
  }else if(type==4){
    msg.pagetype = 2
  }else if(type==1){
    msg.pagetype = 3
  }else if(type==5){
    msg.pagetype = 4
  }else if(type==7){
    msg.pagetype = 5
    msg.subdivideType = 1
  }else if(type==8){
    msg.pagetype = 5
    msg.subdivideType = 2
  }else if(type==9){
    msg.pagetype = 5
    msg.subdivideType = 3
  }else if(type==10){
    msg.pagetype = 5
    msg.subdivideType = 4
  }else if(type==13){
    msg.pagetype = 5
    msg.subdivideType = 5
  }else if(type==11){
    msg.pagetype = 6
  }else{
    msg.pagetype = type
  }
  return msg
}
export function getDataConvert(pagetype:number,subdivideType:number){
  let type = 6
  if(pagetype==1){
    type = 6
  }else if(pagetype==2){
    type = 4
  }else if(pagetype==3){
    type = 1
  }else if(pagetype==4){
    type = 5
  }else if(pagetype==5){
    if(subdivideType==1){
      type = 7
    }else if(subdivideType==2){
      type = 8
    }else if(subdivideType==3){
      type = 9
    }else if(subdivideType==4){
      type = 10
    }else if(subdivideType==5){
      type = 13
    }
  }else if(pagetype==6){
    type = 11
  }else {
    type = pagetype
  }
  return type
}
